import { type CaseReducer } from '@reduxjs/toolkit';

import { initialGlobalFilters } from '../initialState';
import { type FilterGroupState } from '../types';

const resetGlobalsFiltersCase: CaseReducer<FilterGroupState> = state => {
  state.globals = initialGlobalFilters;

  return state;
};

export { resetGlobalsFiltersCase };
